export default function cf7() {
  const wpcf7Elm = document.querySelector( '.wpcf7' );
  const cf7Success = document.querySelector('.cf7-success');
  const cf7Form = document.querySelector('.cf7-contact-form');

  if (wpcf7Elm) {
    wpcf7Elm.addEventListener( 'wpcf7mailsent', function() {
      cf7Success.style.display = 'block';
      cf7Form.style.display = 'none';
    }, false);

    document.querySelector('.cf7-success button ').addEventListener( 'click', function(e) {
      e.preventDefault();
      cf7Success.style.display = 'none';
      cf7Form.style.display = 'block';
    });
  }
}